import { PlusIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

import { Restricted } from 'containers/Restricted';

import { useGoogleAnalyticsDispatcher } from 'hooks/useGoogleAnalyticsDispatcher';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';

import { CREATE_MANUAL_PAYOUT_TEST_ID } from './constants';
import { CreateManualPayoutDialog } from './CreateManualPayoutDialog';

export const CreatePayoutButton = ({ onFinish }: { onFinish?: () => void }) => {
  const [open, setOpen] = useState(false);

  const dispatchGAEvent = useGoogleAnalyticsDispatcher();

  return (
    <div className="flex flex-col gap-4">
      <Restricted
        requiredPermission="payouts:manage"
        key="create-manual-payout"
      >
        <PrimaryButton
          onClick={() => {
            dispatchGAEvent('create_manual_payout_intent', { version: 'v1' });
            setOpen(true);
          }}
          data-testid={CREATE_MANUAL_PAYOUT_TEST_ID}
        >
          <PlusIcon className="size-4 stroke-current" />
          Create payout
        </PrimaryButton>
      </Restricted>
      {open ? (
        <CreateManualPayoutDialog
          onClose={() => setOpen(false)}
          onFinish={onFinish}
          open={open}
        />
      ) : null}
    </div>
  );
};
